/**
 * Bridge Unavailable Overlay
 * 
 * Simple, lightweight popup shown when a bridge is unavailable on web.
 * Renders inside the webview container (position: absolute).
 */

import type { StoreUrls } from '../../bridges/types'

interface Props {
  feature: string
  storeUrls: StoreUrls
  onClose: () => void
}

export function BridgeUnavailableOverlay({ feature, storeUrls, onClose }: Props) {
  // Determine which store to show based on device
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)
  const storeUrl = isIOS ? storeUrls.ios : storeUrls.android
  const downloadUrl = storeUrl || 'https://quapp.io/download'
  
  return (
    <div 
      className="absolute inset-0 z-[100] bg-black/50 flex items-center justify-center p-6"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div 
        className="bg-white rounded-xl w-full max-w-[280px] p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h3 className="text-base font-semibold text-slate-900 text-center">
          {feature}
        </h3>
        
        {/* Message */}
        <p className="text-sm text-slate-500 text-center mt-2 mb-5">
          This feature requires the Quapp Store app.
        </p>
        
        {/* Get App Button */}
        <a 
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full py-2.5 bg-orange-500 text-white text-sm font-medium text-center rounded-lg hover:bg-orange-600 transition-colors"
        >
          Get Quapp Store
        </a>
        
        {/* Continue Button */}
        <button
          onClick={onClose}
          className="block w-full py-2 text-slate-400 text-sm text-center mt-2 hover:text-slate-600 transition-colors"
        >
          Continue in browser
        </button>
      </div>
    </div>
  )
}
